import React from "react";
import "./style.scss";

export default function Others({ other = {} }) {
  const {
    Vehicle,
    CompanyCarNumber,
    InsuranceMonths,
    RemarkFirst,
    RemarkSecond,
    RemarkThird,
    DrivingLicenseNo,
    KmQuantity,
  } = other;
  return (
    <React.Fragment>
      <div className="form-readonly ma-2">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Vehicle</div>
            <div className="form-value">
              <span>{Vehicle}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Company Car Number</div>
            <div className="form-value">
              <span>{CompanyCarNumber}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Insurance Months</div>
            <div className="form-value">
              <span>{InsuranceMonths}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Remark First</div>
            <div className="form-value">
              <span>{RemarkFirst}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Remark Second</div>
            <div className="form-value">
              <span>{RemarkSecond}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Remark Third</div>
            <div className="form-value">
              <span>{RemarkThird}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">Driving License No</div>
            <div className="form-value">
              <span>{DrivingLicenseNo}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">Number of Km</div>
            <div className="form-value">
              <span>{KmQuantity}</span>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
